import { Content } from "@/types/content";
import {
  Box,
  Button,
  Flex,
  HStack,
  Image,
  Text,
  useBreakpointValue,
  useDisclosure,
} from "@chakra-ui/react";
import { ReactSVG } from "react-svg";
import like from "@/assets/like.svg";
import collect from "@/assets/collect.svg";
import comment from "@/assets/comment.svg";
import history from "@/assets/content_history.svg";
import onekeyB from "@/assets/images/onekey_black.svg";
import {
  RiAlignBottom,
  RiDeleteBin4Line,
  RiEyeLine,
  RiSettingsLine,
  RiStarLine,
  RiThumbUpLine,
} from "@remixicon/react";
import DelAiWorksModal from "./delAiWorksModal";
import SettingAiWorksModal from "./setAiWorksModal.tsx";

type Props = {
  works: Content;
};

const MyAiWorksItem = (props: Props) => {
  const { works } = props;
  const delControl = useDisclosure();
  const PublishControl = useDisclosure();

  const handleOpenDel = () => {
    delControl.onOpen();
  };

  const handleOpenSetting = () => {
    PublishControl.onOpen();
  };

  return (
    <Flex>
      <Box w="35%" maxW={"174px"} mr={"10px"} position="relative">
        <Image w="100%" src={works.image_url} />
        <Box
          w={"34px"}
          h="17px"
          bg="rgba(203, 209, 223, 0.32)"
          color={"#FFFFFF"}
          fontSize="8px"
          textAlign={"center"}
          lineHeight="17px"
          position={"absolute"}
          top={0}
          right={0}
        >
          图片
        </Box>
        <Box
          w={"34px"}
          h="17px"
          bg="#000000"
          color={"#FFFFFF"}
          fontSize="8px"
          textAlign={"center"}
          lineHeight="17px"
          position={"absolute"}
          top={0}
          left={0}
        >
          置顶
        </Box>
      </Box>
      <Flex flex={1} flexDirection="column">
        <Box flex={1}>
          <Box fontSize={"18px"} color={"#333333"} fontWeight={500} mb="20px">
            {works.prompt}
          </Box>
          <HStack spacing="15px">
            <Flex alignItems="center">
              <RiEyeLine color="#27314D" size={"14px"} />
              <Text
                color="#27314D"
                fontSize="12px"
                fontFamily="Allerta"
                ml="5px"
              >
                {works.page_view}
              </Text>
            </Flex>
            <Flex alignItems="center">
              <RiThumbUpLine color="#27314D" size={"14px"} />
              <Text
                color="#27314D"
                fontSize="12px"
                fontFamily="Allerta"
                ml="5px"
              >
                {works.like_num}
              </Text>
            </Flex>
            <Flex alignItems="center">
              <RiStarLine color="#27314D" size={"14px"} />
              <Text
                color="#27314D"
                fontSize="12px"
                fontFamily="Allerta"
                ml="5px"
              >
                {works.collect_num}
              </Text>
            </Flex>
            <Flex alignItems="center">
              <ReactSVG src={onekeyB} />
              <Text
                color="#27314D"
                fontSize="12px"
                fontFamily="Allerta"
                ml="5px"
              >
                {works.onekey_nums}
              </Text>
            </Flex>
          </HStack>
        </Box>
        <Box mt="20px">
          <Box color="#8E94A9" fontSize="11px">
            发布于 2024年09月13日 23:22
          </Box>
          <Flex mt={"20px"} gap={"10px"}>
            <Button
              // variant={"unstyled"}
              h="30px"
              p={0}
              bg="none"
              color="#8E94A9"
              fontWeight={"normal"}
              fontSize="14px"
              leftIcon={<RiSettingsLine size={"16px"} />}
              _hover={{
                color: "#366EF4",
                bg: "none",
              }}
              onClick={handleOpenSetting}
            >
              设置
            </Button>
            <Button
              // variant={"unstyled"}
              h="30px"
              p={0}
              bg="none"
              color="#8E94A9"
              fontWeight={"normal"}
              fontSize="14px"
              leftIcon={<RiAlignBottom size={"16px"} />}
              _hover={{
                color: "#366EF4",
                bg: "none",
              }}
            >
              取消置顶
            </Button>
            <Button
              // variant={"unstyled"}
              h="30px"
              p={0}
              bg="none"
              color="#8E94A9"
              fontWeight={"normal"}
              fontSize="14px"
              leftIcon={<RiDeleteBin4Line size={"16px"} />}
              _hover={{
                color: "#366EF4",
                bg: "none",
              }}
              onClick={handleOpenDel}
            >
              删除
            </Button>
          </Flex>
        </Box>
      </Flex>
      <DelAiWorksModal
        isOpen={delControl.isOpen}
        onClose={delControl.onClose}
        delWorks={works}
      />
      <SettingAiWorksModal
        isOpen={PublishControl.isOpen}
        onClose={PublishControl.onClose}
        contentId={works.id}
      />
    </Flex>
  );
};

export default MyAiWorksItem;
